export const TOGGLE_LOADING = 'globalSearch/TOGGLE_LOADING'
export const TOGGLE_LOADING_PAGINATION = 'globalSearch/TOGGLE_LOADING_PAGINATION'
export const GET_SEARCH_DATA = 'globalSearch/GET_SEARCH_DATA'
export const SET_SEARCH_DATA = 'globalSearch/SET_SEARCH_DATA'
export const GET_SEARCH_DATA_PAGINATION = 'globalSearch/GET_SEARCH_DATA_PAGINATION'
export const SET_SEARCH_DATA_PAGINATION = 'globalSearch/SET_SEARCH_DATA_PAGINATION'
export const GET_OPTIONS = 'globalSearch/GET_OPTIONS'
export const SET_OPTIONS = 'globalSearch/SET_OPTIONS'
